import { render } from "./trumpetenterpriseAllocation.vue?vue&type=template&id=95594956&scoped=true"
import script from "./trumpetenterpriseAllocation.vue?vue&type=script&lang=js"
export * from "./trumpetenterpriseAllocation.vue?vue&type=script&lang=js"

import "./trumpetenterpriseAllocation.vue?vue&type=style&index=0&id=95594956&scoped=true&lang=css"
import "./trumpetenterpriseAllocation.vue?vue&type=style&index=1&id=95594956&lang=css"
script.render = render
script.__scopeId = "data-v-95594956"

export default script